// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.alar-cli.json`.

import { Brands } from "app/app-model/constants/brands";
import { Brand } from "app/brand-config";

export const environment = {
  production: true,
  name: 'dev',
  defaultBrand: Brands.Scania,
  redirectUrl: `${window.location.origin}`,
  globalApiUrl: 'https://api.dcode.prod.aws.scania.com/',

  msal: {
    Scania: {
      clientId: 'fdf1aadb-76c6-4e91-8708-05ae8193722d',//dcode_web_dev
      authority: 'https://login.microsoftonline.com/3bc062e4-ac9d-4c17-b4dd-3aad637ff1ac',
      tenantId: '3bc062e4-ac9d-4c17-b4dd-3aad637ff1ac',
      scopes: ['fdf1aadb-76c6-4e91-8708-05ae8193722d/dcodeapp.scope']

    },
    ScaniaCn: {
      clientId: '3b007d03-4fcd-4115-86b1-cacec06572aa', //dcode_cn_web_dev
      authority: 'https://login.partner.microsoftonline.cn/e71a154e-e269-46af-a3af-fdff3eab0663',
      tenantId: 'e71a154e-e269-46af-a3af-fdff3eab0663',
      scopes: ['3b007d03-4fcd-4115-86b1-cacec06572aa/dcode-app.scope']
    },

    International: {
      clientId: 'eb8cb58f-ae16-4739-acdf-de2d3ff34d00',
      authority: 'https://login.microsoftonline.com/b5a920d6-7d3c-44fe-baad-4ffed6b8774d',
      tenantId: 'b5a920d6-7d3c-44fe-baad-4ffed6b8774d',
      scopes: ['eb8cb58f-ae16-4739-acdf-de2d3ff34d00/dcode-app.scope']
    },

    Man: {
      clientId: 'fdf1aadb-76c6-4e91-8708-05ae8193722d',//dcode_web_dev
      authority: 'https://login.microsoftonline.com/3bc062e4-ac9d-4c17-b4dd-3aad637ff1ac',
      tenantId: '3bc062e4-ac9d-4c17-b4dd-3aad637ff1ac',
      scopes: ['df1aadb-76c6-4e91-8708-05ae8193722d/dcodeapp.scope']
    }
  },

  // ---- API CONFIGURATION ----
  // --- API config used by MSAL interceptor (Graph + backend) ---
  apiConfig: [
    {
      key: 'profile',
      apiScopes: [],
      graphScopes: ["openid", "profile", "User.Read"],
      uri: 'https://graph.microsoft.com/v1.0/me',
    },
    {
      key: 'profile-pic',
      graphScopes: ['user.read'],
      apiScopes: [],
      uri: 'https://graph.microsoft.com/v1.0/me/photo/$value',
    },
    {
      key: 'backend',
      // Brand-specific backend scopes (3 Entra API apps = 3 app IDs)
      apiScopesPerBrand: {
        Scania: ['95e0740b-4399-49b8-bd09-ff3acd8a7434/dcode-api.scope'],
        ScaniaCn: ['3b007d03-4fcd-4115-86b1-cacec06572aa/dcode-app.scope'],
        International: ['c8e94b5f-b803-4696-ae40-3b841ce5404c/dcode-api.scope'],
        Man: ['api://<MAN-api-app-id>/.default'], // TODO: update when known
      } as Record<Brand, string[]>,
      graphScopes: [],
      uri: 'https://api.dcode.devtest.aws.scania.com/*',
    },
  ],
};
